<template>
  <div>
    <bs-page-title :titleLabel="'会場マスタ編集'" :btnLabel="''"></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{ alertMessage }}</bs-msg-alert>
    <form @submit.prevent="save_data" @keydown.enter.prevent="save_data">
      <div v-for="field in fields" :key="field.name" class="row mb-3">
        <div class="col-2 mb-2">
          <p class="text-center py-1 fs-6">{{ field.label }}<span v-if="field.required" class="text-danger">*</span></p>
        </div>
        <div class="col-4 mb-2">
          <input
            v-if="!field.options && field.type !== 'select' && field.name !== 'mfj_hall_hall_cd' && field.type !== 'date'"
            :type="field.type === 'integer' ? 'number' : 'text'"
            class="form-control"
            v-model="formData[field.name]"
            :placeholder="field.placeholder"
            :required="field.required"
          />
          <input
            v-else-if="field.name === 'mfj_hall_hall_cd'"
            type="text"
            class="form-control"
            v-model="formData.mfj_hall_hall_cd"
            :disabled="isEdit"
            :placeholder="field.placeholder"
            :required="field.required"
          />
          <input
            v-else-if="field.type === 'date'"
            type="date"
            class="form-control"
            v-model="formData[field.name]"
            :placeholder="field.placeholder"
            :required="field.required"
          />
          <select
            v-else
            class="form-select"
            v-model="formData[field.name]"
          >
            <option value="">選択してください</option>
            <option v-for="opt in field.options || []" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
          </select>
          <small v-if="field.help" class="form-text text-muted">{{ field.help }}</small>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <button class="btn btn-primary me-2" type="button" @click="save_data">保存</button>
          <button class="btn btn-secondary" @click="go_back" type="button">戻る</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { getMasterFormFields } from '@/utils/masterHelpers'
import BsPageTitle from '../../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../../atoms/BsMsgAlert.vue'
import config from '@/const'

export default {
  name: 'HallEditView',
  data() {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      formData: {},
      fields: [],
      isEdit: false
    }
  },
  components: {
    BsPageTitle,
    BsMsgAlert
  },
  methods: {
    async save_data() {
      try {
        Object.keys(this.formData).forEach(key => {
          if (this.formData[key] === null || this.formData[key] === undefined) {
            this.formData[key] = ''
          }
        })
        
        // 日付フィールドをYYYYMMDD形式に変換
        const convertDateToYYYYMMDD = (val) => {
          if (!val) return null;
          // YYYY-MM-DD 形式の場合
          if (typeof val === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(val)) {
            return val.replace(/-/g, '');
          }
          // 既に8桁の場合はそのまま返す
          if (typeof val === 'string' && /^\d{8}$/.test(val)) {
            return val;
          }
          return val;
        };
        
        // 日付フィールドの変換
        this.fields.forEach(field => {
          if (field.type === 'date' && this.formData[field.name]) {
            this.formData[field.name] = convertDateToYYYYMMDD(this.formData[field.name]);
          }
        });
        
        for (const field of this.fields) {
          if (field.required && !this.formData[field.name]) {
            this.alertMessage = `${field.label}は必須です`
            this.alertClass = 'alert-danger'
            this.$forceUpdate()
            return
          }
          if (field.type === 'integer' && this.formData[field.name] && isNaN(Number(this.formData[field.name]))) {
            this.alertMessage = `${field.label}は数値で入力してください`
            this.alertClass = 'alert-danger'
            this.$forceUpdate()
            return
          }
        }
        const params = {
          ...this.formData,
          master_type: 'hall'
        }
        const isNew = !this.$route.params.id || this.$route.params.id === 'new'
        const url = isNew 
          ? `${config.BASE_API_URL}/?s=api&c=api&m=masters/create&type=hall`
          : `${config.BASE_API_URL}/?s=api&c=api&m=masters/update&type=hall&id=${this.$route.params.id}`
        const method = isNew ? 'POST' : 'PUT'
        const response = await this.basicPosts_S(url, params, method)
        if (response.data && response.data.status === 200) {
          this.alertMessage = response.data.alert?.message || (isNew ? 'データを作成しました' : 'データを更新しました')
          this.alertClass = response.data.alert?.addClass || 'alert-success'
          localStorage.removeItem('data')
          setTimeout(() => {
            this.go_back()
          }, 1500)
        } else {
          this.alertMessage = response.data?.alert?.message || (isNew ? 'データの作成に失敗しました' : 'データの更新に失敗しました')
          this.alertClass = response.data?.alert?.addClass || 'alert-danger'
        }
      } catch (error) {
        console.error('データの保存に失敗しました:', error)
        this.alertMessage = 'データの保存に失敗しました'
        this.alertClass = 'alert-danger'
      }
    },
    go_back() {
      localStorage.removeItem('data')
      this.$router.push('/master/list')
    }
  },
  created() {
    this.fields = getMasterFormFields('hall')
    // 日付フォーマット関数
    const normalizeDate = (val) => {
      if (!val) return '';
      // 数値の場合は文字列に変換
      if (typeof val === 'number') {
        val = val.toString();
      }
      // YYYYMMDD形式（8桁）→ YYYY-MM-DD
      if (/^\d{8}$/.test(val)) {
        return val.slice(0,4) + '-' + val.slice(4,6) + '-' + val.slice(6,8);
      }
      // YYYYMM形式（6桁）→ YYYY-MM-01
      if (/^\d{6}$/.test(val)) {
        return val.slice(0,4) + '-' + val.slice(4,6) + '-01';
      }
      // 既にYYYY-MM-DD形式の場合はそのまま返す
      if (/^\d{4}-\d{2}-\d{2}$/.test(val)) {
        return val;
      }
      return val;
    }
    const data = localStorage.getItem('data');
    if (data) {
      const obj = JSON.parse(data);
      this.fields.forEach(field => {
        if (field.type === 'date') {
          this.formData[field.name] = normalizeDate(obj[field.name])
        } else {
          this.formData[field.name] = obj[field.name] || ''
        }
      })
      this.isEdit = true;
    } else {
      this.fields.forEach(field => {
        this.formData[field.name] = ''
      })
      this.isEdit = false;
    }
    // 初期メッセージを削除
    this.alertMessage = '更新できます';
  },
  mounted() {
  }
}
</script>

<style scoped>
.btn-light.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
}
.btn-light.btn-outline-secondary:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
</style> 